const EnglishToPersian = (v) => {
  const e = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  let array = [];
  if (v || v === 0) {
    array = v.toString().split("");
  }
  let newNumber = [];
  array.forEach((i) => {
    if (i === "." || e.indexOf(i) !== -1) {
      newNumber.push(i);
    } else
      e.forEach((j, index) => {
        if (parseInt(i) === parseInt(index)) {
          newNumber.push(e[index]);
          return;
        }
      });
  });
  return newNumber.join("");
};
export default EnglishToPersian;
